
import React  from "react";

import SearchContainer from "../containers/SearchContainer";
import FiktivSearchResults from "./FiktivSearchResults";

const Fiktiv = ({hundId, kjoenn, sisteHunder, favoritter}) => {


    return (
        <SearchContainer>
            { props => (
                <FiktivSearchResults {...props} hundId={hundId} kjoenn={kjoenn} sisteHunder={sisteHunder} favoritter={favoritter} />
            )}
        </SearchContainer>
    );
};

export default Fiktiv;
